import {
  faDolly,
  faCoins,
  faSitemap,
  faBullhorn,
  faFileSignature,
  faFlag,
  faDesktop,
} from '@fortawesome/free-solid-svg-icons';
import { faBullseyePointer } from '@fortawesome/pro-regular-svg-icons';
import { faHexagonImage } from '@fortawesome/pro-solid-svg-icons';
import { headerNames } from './constants';

const parentPath = '/site-administration';

export const siteAdministrationRoutes = {
  siteAdministration: {
    path: `${parentPath}`,
    key: 'site-administration-portal-all-products',
    value: headerNames?.siteAdministration,
    icon: faDesktop,
    QADataTag: 'allProductsNav',
    permission: 'shopping.products.view',
  },
  featureFlags: {
    path: `${parentPath}?t=feature-flags`,
    key: 'site-administration-feature-flag',
    value: 'Feature Flags',
    icon: faFlag,
    QADataTag: 'featureFlagNav',
    permission: 'wallet.erc20tokens.view',
  },
  tokenConfiguration: {
    path: `${parentPath}?t=erc-20-tokens`,
    key: 'site-administration-token-configuration',
    value: 'ERC-20 Tokens',
    icon: faCoins,
    QADataTag: 'tokenConfigurationNav',
    permission: 'wallet.erc20tokens.view',
  },
  nftCollections: {
    path: `${parentPath}?t=nft-collections`,
    key: 'site-administration-nft-collections',
    value: 'NFTs',
    icon: faHexagonImage,
    QADataTag: 'nftCollectionsNav',
    permission: 'wallet.erc20tokens.view',
  },
  products: {
    path: `${parentPath}?t=products`,
    key: 'site-administration-products',
    value: 'Products',
    icon: faDolly,
    QADataTag: 'productsNav',
    permission: 'shopping.products.view',
  },
  categories: {
    path: `${parentPath}?t=categories`,
    key: 'site-administration-categories',
    value: 'Product Categories',
    icon: faSitemap,
    QADataTag: 'allProductCategoriesNav',
    permission: 'shopping.products.view',
  },
  campaigns: {
    path: `${parentPath}?t=campaigns`,
    key: 'site-administration-campaigns',
    value: 'Campaigns',
    icon: faBullhorn,
    QADataTag: 'campaignsNav',
    permission: 'rewards.campaigns.view',
  },
  agreements: {
    path: `${parentPath}?t=agreements`,
    key: 'site-administration-agreements',
    value: 'Agreements',
    icon: faFileSignature,
    QADataTag: 'agreementsNav',
    permission: 'rewards.agreements.view',
  },
  actionLogs: {
    path: `${parentPath}?t=action-logs`,
    key: 'site-administration-action-logs',
    value: 'Action Logs',
    icon: faBullseyePointer,
    QADataTag: 'actionLogsNav',
    permission: 'actionlog.site.view',
  },
};
